import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { resetAccountState } from '../reducers/account.reducer';
import { baseService } from 'service';
import { AppDispatch } from 'store/store';
import { LoginPayloadType } from 'types/user.type';
import { UserInfoDto } from 'service/dto/user.dto';

// 3 args: return type, payload type, thunkAPI config object; contains getState
export const login = createAsyncThunk<UserInfoDto, LoginPayloadType>(
  'auth/login',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await baseService.post(
        '/auth/login',
        {
          email,
          password
        },
        { withCredentials: true }
      );
      return response.data;
    } catch (error: any) {
      const err = error as AxiosError;
      if (!error.response) {
        throw err;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const logout = () => (dispatch: AppDispatch) => {
  baseService
    .post('/auth/logout')
    .then(response => {
      // DISPATCH EACH REDUCER'S RESET ACTION HERE
      if (response.data === 'success') {
        dispatch(resetAccountState());
      }
    })
    .catch(err => {
      console.log('Logout error', err);
    });
};

export const fetchUserInformation = createAsyncThunk<UserInfoDto, void>(
  'users/user',
  async (_, { rejectWithValue }) => {
    try {
      const response = await baseService.get('/users/user');
      return response.data;
    } catch (err) {
      const error = err as AxiosError;
      if (!error.response) {
        throw err;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
